import { createAction } from '@reduxjs/toolkit';
export const setCrossTabState = createAction('stylovyze/automaticUpdates/setCrossTabState');
export const fullSetCrossTabState = createAction('stylovyze/automaticUpdates/fullSetCrossTabState');
